import React from 'react';
import { CloudUpload, Search } from 'lucide-react';

const DocumentHeader = ({
  searchTerm,
  onSearchChange,
  onAddNew,
  filters,
  onFilterChange,
  typesDocuments,
  soutenances
}) => {
  return (
    <>
      {/* Header principal */}
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Documents de Soutenance</h2>
          <p className="text-gray-600">Gérer les documents liés aux soutenances</p>
        </div>
        <button
          onClick={onAddNew}
          className="bg-gradient-to-r from-indigo-600 to-indigo-700 text-white px-4 py-2 rounded-lg hover:from-indigo-700 hover:to-indigo-800 transition-all duration-200 flex items-center space-x-2 shadow-lg"
        >
          <CloudUpload className="h-5 w-5" />
          <span>Uploader Document</span>
        </button>
      </div>

      {/* Filtres */}
      <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 mb-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Soutenance
            </label>
            <select
              value={filters.soutenance}
              onChange={(e) => onFilterChange({ ...filters, soutenance: e.target.value })}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="">Toutes les soutenances</option>
              {soutenances.map(soutenance => (
                <option key={soutenance.id} value={soutenance.id}>
                  {soutenance.etudiant_principal_info ? 
                    `${soutenance.etudiant_principal_info.nom} ${soutenance.etudiant_principal_info.prenom}` : 
                    soutenance.titre_travail.substring(0, 30)
                  }
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Type de document
            </label>
            <select
              value={filters.type_document}
              onChange={(e) => onFilterChange({ ...filters, type_document: e.target.value })}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="">Tous les types</option>
              {typesDocuments.map(type => (
                <option key={type.value} value={type.value}>
                  {type.label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Recherche
            </label>
            <div className="relative">
              <Search className="h-5 w-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
                className="w-full border border-gray-300 rounded-lg pl-10 pr-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Titre, étudiant..."
              />
            </div>
          </div>

          <div className="flex items-end">
            <button
              onClick={() => {
                onFilterChange({
                  type_document: '',
                  soutenance: ''
                });
                onSearchChange('');
              }}
              className="w-full px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Réinitialiser
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DocumentHeader; 